import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export const setMergedViewEnabledAccount = mutatorAction(
    'SET_MERGED_VIEW_ENABLED_ACCOUNT',
    (primarySmtpAddress: string) => {
        getStore().mergedViewEnabledAccount = primarySmtpAddress;
    }
);
